<template>
    <v-container>
        <!-- Modal con los datos del pago -->
        <PagoExitoModal v-if="pagoExitoso" :pago="pagoExitoso" />
        <v-row>
            <!-- Sección Detalle Recibo -->
            <v-col cols="12" md="6">
                <v-card outlined>
                    <v-card-title class="headline">Detalle del Recibo</v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <strong>ID de Pago:</strong> {{ recibo.idPago }}<br>
                                <strong>Contrato:</strong> {{ recibo.contrato }}<br>
                                <strong>Recibo:</strong> {{ recibo.numPago }} de {{ recibo.numPagos }}<br>
                                <strong>Plan:</strong> {{ recibo.plan }}<br>
                                <!-- <strong>Colectividad:</strong> {{ recibo.colectividad }}<br>
                                <strong>Agente:</strong> {{ recibo.idAgente }}<br> -->
                            </v-col>

                            <v-col cols="12" sm="6">
                                <strong>Fecha Inicio:</strong> {{ formatDate(recibo.fecIni) }}<br>
                                <strong>Fecha Fin:</strong> {{ formatDate(recibo.fecFin) }}<br>
                                <strong>Monto:</strong> {{ $formatCurrency(recibo.montoPago) }}<br>
                                <strong>Gatos expedición:</strong> {{ $formatCurrency(recibo.gastoExp) }}<br>
                                <strong>Pagado:</strong>
                                <v-chip :color="recibo.isPagado ? 'green' : 'red'" dark>
                                    {{ recibo.isPagado ? 'Sí' : 'No' }}
                                </v-chip>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4"></v-divider>
                        <h3 v-show="(recibo?.pagosPendientes || []).length > 0">Pagos Pendientes</h3>
                        <v-data-table v-show="(recibo?.pagosPendientes || []).length > 0" :headers="headers"
                            :items="recibo?.pagosPendientes" dense class="elevation-1">
                            <template v-slot:[`item.pagoFecha`]="{ item }">
                                {{ formatDate(item.pagoFecha) }}
                            </template>
                            <template v-slot:[`item.montoPago`]="{ item }">
                                {{ $formatCurrency(item.montoPago) }}
                            </template>
                            <template v-slot:[`item.isPagado`]="{ item }">
                                <v-chip :color="item.isPagado ? 'green' : 'orange'" dark small>
                                    {{ item.isPagado ? 'Pagado' : 'Pendiente' }}
                                </v-chip>
                            </template>
                        </v-data-table>

                        <v-row justify="end" class="mt-2">
                            <v-col cols="auto">
                                <h3 class="mb-2">Total a pagar:</h3>
                                <h2 class="font-weight-bold text--primary">{{ $formatCurrency(totalPago) }}</h2>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card class="pa-4" elevation="6">
                    <v-card-title class="text-h6 text-center">Pago seguro</v-card-title>
                    <v-form ref="formPago" v-model="formValido" lazy-validation>
                        <v-row dense>
                            <v-col cols="12">
                                <v-text-field label="Nombre en la tarjeta" outlined dense v-model="card.name"
                                    prepend-inner-icon="mdi-account" :rules="[rules.ruleRequired, rules.ruleNombre]"
                                    @input="card.name = card.name?.toUpperCase()"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Correo electrónico" :rules="[rules.ruleRequired, rules.ruleEmail]"  outlined dense v-model="correo"
                                    prepend-inner-icon="mdi-email"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field label="Telefono" :rules="[rules.ruleRequired, rules.ruleTelephone]"  outlined dense v-model="telefono"
                                    prepend-inner-icon="mdi-phone"></v-text-field>
                            </v-col>
                            <v-col cols="10">
                                <v-text-field label="Número de tarjeta" outlined dense
                                    prepend-inner-icon="mdi-credit-card" v-mask="'#### #### #### ####'"
                                    v-model="card.number" @input="changeNumTarjet"
                                    :rules="[rules.ruleRequired, ruleCardNumber]" maxlength="19"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-img class="bg-grey-lighten-2" v-show="!this.visa" height="40" cover
                                    src="https://medicover.mx/img/visa.svg"></v-img>
                                <v-img v-show="!this.mastercard" class="bg-grey-lighten-2" height="40" cover
                                    src="https://medicover.mx/img/mastercard.svg"></v-img>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="4">
                                <v-select v-model="card.exp_month" :items="months" label="Mes" outlined dense
                                    prepend-inner-icon="mdi-calendar-month" :rules="[rules.ruleRequired]"
                                    class="v-icon--small"></v-select>
                            </v-col>
                            <v-col cols="4">
                                <v-select v-model="card.exp_year" :items="years" label="Año" outlined dense
                                    prepend-inner-icon="mdi-calendar-range" :rules="[rules.ruleRequired]"></v-select>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field label="CVV" v-model="card.cvc" outlined dense type="password"
                                    v-mask="'###'" prepend-inner-icon="mdi-lock" maxlength="3"
                                    :rules="[rules.ruleRequired]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" class="text-right">
                                <v-btn color="primary" :disabled="!formValido && totalPago > 0" @click="crearToken"
                                    block class="mt-4">
                                    <v-icon left>mdi-lock</v-icon>
                                    Pagar de forma segura ${{ totalPago.toFixed(2) }}
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="12" class="text-center">
                                <politica-privacidad />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PoliticaPrivacidad from '@/components/Pagos/politicaPrivacidadComponent.vue'
import PagoExitoModal from '@/components/Pagos/modalPagoRealizado.vue'

export default {
    props: {
        recibo: {
            type: Object,
            required: true
        }
    },
    components: {
        PoliticaPrivacidad,
        PagoExitoModal
    },
    computed: {
        totalPago() {
            const recibo = this.recibo || {}; // asegura que sea un objeto
            const pagos = Array.isArray(recibo.pagosPendientes) ? recibo.pagosPendientes : [];

            if (pagos.length === 0) {
                return recibo.montoPago || 0;
            }

            return pagos.reduce((sum, pago) => {
                if (!pago.isPagado) {
                    return sum + (pago.montoPago || 0) + (pago.gastoExp || 0) + recibo.montoPago || 0;
                }
                return sum;
            }, 0);
        },
        rules() {
            return this.$rules;
        },
        Carrito() {
            const recibo = this.recibo || {};
            const pagos = [];

            // Agregar el pago actual (si no está pagado)
            if (recibo.isPagado === 0) {
                pagos.push({
                    name: `Pago ID: ${recibo.idPago} `,
                    unit_price: Math.round(((recibo.montoPago || 0) + (recibo.gastoExp || 0)) * 100),
                    quantity: 1
                });
            }

            // Agregar pagos pendientes si existen
            const pendientes = Array.isArray(recibo.pagosPendientes) ? recibo.pagosPendientes : [];

            pendientes.forEach(p => {
                if (p.isPagado === 0) {
                    pagos.push({
                        name: `Pago ID: ${p.idPago}`,
                        unit_price: Math.round(((p.montoPago || 0) + (p.gastoExp || 0)) * 100),
                        quantity: 1
                    });
                }
            });

            return pagos;
        }
    },
    mounted() {
        if (typeof Conekta !== 'undefined') {
            //eslint-disable-next-line no-undef
            Conekta.setPublicKey(process.env.VUE_APP_CONEKTA_PUBLIC_KEY); // Reemplaza con tu llave pública
        } else {
            console.error('Conekta no está definido. Verifica que se cargó el script correctamente.');
        }
    },
    data() {
        return {
            pagoExitoso: null,
            correo: 'karen@gmail.com',
            telefono: '4446638189',
            card: {
                //  number: '4000 0000 0000 9995',//fondos insuficientes
                // number: '4242424242424242', //rechazada
                //number: '4000 0000 0000 3220' //3D Secure requerido
                // number: '4000 0000 0000 9234', //error banko
                //number: '4000 0000 0000 0119', //declinada
                // number: '5105 1051 0510 5100', //mastercard
                number: '5105105105105100',
                name: 'Karen Castillo',
                exp_month: '08',
                exp_year: '2026',
                cvc: '123',
            },
            months: [
                { text: '01', value: '01' },
                { text: '02', value: '02' },
                { text: '03', value: '03' },
                { text: '04', value: '04' },
                { text: '05', value: '05' },
                { text: '06', value: '06' },
                { text: '07', value: '07' },
                { text: '08', value: '08' },
                { text: '09', value: '09' },
                { text: '10', value: '10' },
                { text: '11', value: '11' },
                { text: '12', value: '12' },
            ],
            years: Array.from({ length: 6 }, (_, i) => String(new Date().getFullYear() + i)),

            ruleCardNumber: (v) =>
                /^4\d{3} \d{4} \d{4} \d{4}$|^5[1-5]\d{2} \d{4} \d{4} \d{4}$/.test(v) ||
                "Tarjeta inválida (Visa/Mastercard)",
            ruleExpDate: (v) => {
                if (!/^\d{2}\/\d{2}$/.test(v)) return "Formato inválido (MM/AA)";
                const [mes, año] = v?.split("/").map(Number);
                const añoActual = new Date().getFullYear() % 100;
                const mesActual = new Date().getMonth() + 1;
                if (año < añoActual || (año === añoActual && mes < mesActual))
                    return "Tarjeta expirada";
                return true;
            },
            ruleCVV: (v) => /^\d{3}$/.test(v) || "CVV inválido (3 dígitos)",
            visa: true,
            mastercard: true,
            formValido: false,
            Id: null,
            headers: [
                { text: '# recibo', value: 'numPago' },
                { text: 'Fecha de Pago', value: 'pagoFecha' },
                { text: 'Monto', value: 'montoPago' },
                { text: 'Gasto Exp.', value: 'gastoExp' },
                { text: 'Estado', value: 'isPagado' }
            ]
        };
    },
    methods: {
        formatDate(dateStr) {
            if (!dateStr) return '';
            return new Date(dateStr).toLocaleDateString();
        },
        procesarPago() {
            if (this.$refs.formPago.validate()) {
                alert("✅ Pago exitoso con la tarjeta de " + this.Pago.Titular);
            }
        },
        changeNumTarjet(value) {
            let firstChar1 = value[0];
            if (firstChar1 === "4") { //visa
                this.mastercard = true
                this.visa = false
            }
            if (firstChar1 === "5") {//mastercard
                this.visa = true
                this.mastercard = false
            }
        },
        crearToken() {
            //eslint-disable-next-line no-undef
            Conekta.Token.create({ card: this.card }, this.tokenSuccess, this.tokenError);
        },
        tokenSuccess(token) {
            
       const esValido = this.$refs.formPago.validate();
      if (esValido) {
                this.$http.post(`pagolinea/CrearPago`, {
                    tokenId: token.id,
                    nombre: this.card.name,
                    email: this.correo, // puedes pedirlo en formulario
                    telefono: this.telefono,
                    carrito: this.Carrito,
                    amount: this.totalPago
                })
                .then(response => {
                    //console.log(response)
                    this.pagoExitoso = response.data.orden
                })
                .catch((err) => {
                    let mensajeError = 'Ups, tuvimos un error no esperado. <b>Intenta más tarde</b>.';

                    if (err.response) {
                        console.log(err.response)
                        mensajeError = err.response.data?.mensaje
                        /*
                        const detalles = err.response.data?.details;

                        if (Array.isArray(detalles) && detalles.length > 0) {
                            // Muestra los mensajes de detalle que da Conekta
                            mensajeError = detalles.map(e => `<p>${e.message}</p>`).join('');
                        } else if (err.response.data?.message) {
                            mensajeError = `<p>${err.response.data.message}</p>`;
                        }
                            */
                    }

                    this.$swal.fire({
                        position: 'center',
                        html: mensajeError,
                        icon: 'error',
                        confirmButtonText: 'Cerrar',
                        showCloseButton: true,
                        showConfirmButton: true,
                        backdrop: false
                    });
                })
                .finally(() => {
                });
            }
        },
        tokenError(err) {

            console.error(err);

            this.$swal.fire({
                position: 'center',
                html: 'Existe un error en el servicio, puedes intentar mas tarde.',
                icon: 'error',
                confirmButtonText: 'Cerrar',
                showCloseButton: true,
                showConfirmButton: true,
                backdrop: false
            });
        }
    }
};
</script>

<style scoped>
.v-chip {
    font-weight: bold;
}
</style>
